/* TODO: (D.K.) Need to reuse such constants from */
/* this -> import { LIGHT_TYPE, DARK_TYPE } from '@yme/tokens/colorSchema'; */
export const LIGHT_ACCORDION = 'LIGHT';
export const DARK_ACCORDION = 'DARK';
